import { useEffect } from 'react';
import { useTeamChat } from '../store/TeamChatContext';
import { TEAM_CHAT_OPEN_FLOATING } from '../utils/teamChatEvents';

/** Listens for `TEAM_CHAT_OPEN_FLOATING` (e.g. from Command Center) and opens a floating DM. */
export function TeamChatEventBridge() {
  const { openFloatingChat } = useTeamChat();
  useEffect(() => {
    const h = (e: Event) => {
      const ce = e as CustomEvent<{ peerId?: string }>;
      if (ce.detail?.peerId) openFloatingChat(ce.detail.peerId);
    };
    window.addEventListener(TEAM_CHAT_OPEN_FLOATING, h as EventListener);
    return () => window.removeEventListener(TEAM_CHAT_OPEN_FLOATING, h as EventListener);
  }, [openFloatingChat]);
  return null;
}
